import React from "react";

import unrecognizedDocsStyles from "./ManageUnrecognizedDoc.module.css";
import { IconButton, Typography } from "@material-ui/core";
import moment from 'moment';
import { RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { RadioButtonUnchecked, RadioButtonChecked } from '@material-ui/icons';
import { Theme, createStyles, withStyles } from '@material-ui/core';

import UnrecognizedDocs from "../../../models/AutoDocRecognitionResponse";

const styles = (theme: Theme) =>

  createStyles({
    radioBtn: {
      padding: '0 10px 0 0px',
    },
    radioIcon: {
      fontSize: '18px'
    },
    radioLabel: {
      paddingBottom: '15px',
      margin: '0 0 15px 0',
      '& p': {
        margin: '1px',
      },
      '&:first-child p:first-child': {
        marginTop: '0 !important',
      }
    },
    txtColor: {
      color: 'var(--secondarygreen)',
      fontSize: '12px,',
      fontWeight: 500,
    },
    docInfoColor: {
      color: '#c5c5c5',
    },
    radioWhite: {
      color: 'white',
      fontSize: '18px'
    },
    borderBottom: {
      borderBottom: '1px solid #8080809e',
    },
    labelTypo: {
      fontSize: '12px',
    },
    infoParent: {
      width: '100%',
    }
  });

interface UnrecognizedDocsListComponentProps {
  classes: any;
  unrecognizedDocsList: Array<UnrecognizedDocs>;
  handleChangeUnrecognizedDoc: (event: any, type: string) => void;
  selUnrecognizedDoc: string;
};

const UnrecognizedDocsListComponent = (props: UnrecognizedDocsListComponentProps) => {

  const { classes } = props;
  const unrecognizedDocsList: Array<JSX.Element> = props.unrecognizedDocsList.map((item: any, j) => {
    return (
      <FormControlLabel
        key={ j }
        value={ item.id.toString() }
        className={ `${classes.radioLabel} ${classes.borderBottom}` }
        control={
          <Radio
            className={ classes.radioBtn }
            icon={ <RadioButtonUnchecked className={ classes.radioWhite } color='primary' /> }
            checkedIcon={ <RadioButtonChecked className={classes.radioWhite} color='primary' /> }
          />
        }
        label={<Typography className={ classes.labelTypo }>
          <p className={ classes.txtColor }>{moment(item.received_date).format('DD MMM YY HH:mm z')}</p>
          <p className={ classes.docInfoColor }>From Email: { item.scanner_from_email }</p>
        </Typography>}
      />
    );
  });

  return (
    <div className={ unrecognizedDocsStyles.unRecognizeddocumentCol }>
      <div className={ unrecognizedDocsStyles.infoParent }>
        <RadioGroup
          name="unrecognizedDoc"
          value={ props.selUnrecognizedDoc }
          onChange={ (e) => props.handleChangeUnrecognizedDoc(e, 'manual') }
        >
          { unrecognizedDocsList }
        </RadioGroup>
      </div>
    </div>
  );
};

export default withStyles(styles)(UnrecognizedDocsListComponent);
